import React, { useState } from 'react';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';

import MbInput from 'components/atoms/MbInput';
import OutlinedButton from 'components/atoms/OutlinedButton';

const useStyles = makeStyles((theme) => ({
  textBox: {
    backgroundColor: '#fff',
  },
}));

const AdexSearchTextBox = (props) => {
  const { t } = useTranslation();
  const { params, setParams } = props;
  const [value, setValue] = useState('');

  const classes = useStyles();

  /**
   * 수정 클릭
   * @param {string} name
   * @param {*} value
   */
  const handleOnClick = () => (e) => {
    if (value !== '') {
      setParams({ ...params, keyword: value });
    } else {
      alert(t('검색어를 입력해주세요.'));
    }
  };

  const onChange = () => (e) => {
    setValue(e.target.value);
  };

  let icon = false;

  return (
    <>
      <MbInput
        className={classes.textBox}
        name="keyword"
        value={value}
        onChange={onChange()}
        margin="normal"
        placeholder={t('지면명/스크립트번호/아이디')}
        style={{
          width: 200,
          margin: '0 7px 0 0',
          height: 35,
        }}
        InputProps={icon}
      />
      <OutlinedButton
        className="mb-product-code-button"
        onClick={handleOnClick()}
      >
        {i18next.t('검색')}
      </OutlinedButton>
    </>
  );
};

export default AdexSearchTextBox;
